import { SectorBoard } from '@/features/sector/SectorBoard';
import { SimulateurTabs } from '@/features/simulations/SimulateurTabs';

export function SimulateurSecteursPage() {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-2xl font-semibold">Simulateur</h1>
      <SimulateurTabs />
      <SectorBoard />
    </div>
  );
}
